export default [
  {
    name: 'category',
    display: true,
    sortable: false,
    width: 300,
    translationKey: 'table.headers.category_subcategory',
  },
  {
    name: 'leagueAvg',
    display: true,
    sortable: false,
    isAverageOfLeague: true,
    translationKey: 'table.headers.league',
  },
  {
    name: 'totalAccumulated',
    display: true,
    sortable: false,
    translationKey: 'table.headers.player',
  },
  // {
  //   name: 'lastMatch',
  //   title: 'ULTIMO PARTIDO',
  //   display: true,
  //   sortable: false,
  // },
  {
    name: 'period1',
    title: 'MIN  0 - 15',
    display: true,
    sortable: false,
  },
  {
    name: 'period2',
    title: 'MIN 16 - 30',
    display: true,
    sortable: false,
  },
  {
    name: 'period3',
    title: 'MIN 31 - 45',
    display: true,
    sortable: false,
  },
  {
    name: 'period4',
    title: 'MIN 45 - 60',
    display: true,
    sortable: false,
  },
  {
    name: 'period5',
    title: 'MIN 61 - 75',
    display: true,
    sortable: false,
  },
  {
    name: 'period6',
    title: 'MIN 76 - 90',
    display: true,
    sortable: false,
  },
];
